<div class="m-frm__group aw-2-d--inline-block m-frm--icon search" [class.search--filled]="variant() === 'filled'">
  <input
    #searchField
    type="search"
    class="m-frm__control"
    autocomplete="off"
    autocapitalize="off"
    autocorrect="off"
    [placeholder]="placeholder()"
    [attr.aria-label]="placeholder()"
    (keyup.enter)="enter.emit()"
    (focus)="focused.emit()"
    (blur)="blurred.emit()"
  />
  <i class="aw-2-icn m-frm__icon" aria-hidden="true" awIcon="search"></i>

  @if (currentValueState() !== '') {
    <button type="button" class="search-clear" [attr.aria-label]="commonTranslations.clear" (click)="clear()">
      <i class="aw-2-icn" aria-hidden="true" awIcon="close"></i>
    </button>
  }
</div>
